import { render, staticRenderFns } from "./PrintTable.vue?vue&type=template&id=70810310&"
import script from "./PrintTable.vue?vue&type=script&lang=js&"
export * from "./PrintTable.vue?vue&type=script&lang=js&"
import style0 from "./PrintTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports